export const Endpoint = process.env.REACT_APP_API_URL
export const prefix = 'boxsize'
export const boxSizeConstants = {
    API_GETBYID: `${Endpoint}/${prefix}`,
    API_GETALL: `${Endpoint}/${prefix}`,
    API_GETALL_SEARCH: `${Endpoint}/${prefix}/search`,
    API_CREATE: `${Endpoint}/${prefix}/create`,
    API_DELETE: `${Endpoint}/${prefix}/delete`,
    API_UPDATE: `${Endpoint}/${prefix}/update`,
  
    INSERT_SUCCESS: 'BOXSIZE_INSERT_SUCCESS',
    INSERT_FAILURE: 'BOXSIZE_INSERT_FAILURE',

    UPDATE_SUCCESS: 'BOXSIZE_UPDATE_SUCCESS',
    UPDATE_FAILURE: 'BOXSIZE_UPDATE_FAILURE',
  
    DELETE_SUCCESS: 'BOXSIZE_DELETE_SUCCESS',
    DELETE_FAILURE: 'BOXSIZE_DELETE_FAILURE',
    
    GET_ALL: 'BOXSIZE_GET_ALL',
    GET_DATA: 'BOXSIZE_GET_DATA',
    GET_SELECT: 'BOXSIZE_GET_SELECT',

    GET_FAILURE: 'BOXSIZE_GET_FAILURE',
    CLEAR_DATA: 'BOXSIZE_CLEAR_DATA'
}
